/** Internal dependencies */
import { swiperFromConfig } from '../../../../../assets/src/scripts/utilities/swiperFromConfig';

if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    if (!window.Swiper) {
        return;
    }

    const sliders = document.querySelectorAll('.ct_slider');

    if (sliders) {
        sliders.forEach((slider) => {
            const sliderContainer = slider.querySelector('.swiper');

            if (!sliderContainer) {
                return;
            }

            const userConfig = JSON.parse(slider.dataset.ctSliderConfig);

            // override defaults set in `swiperFromConfig` by adding to the `userConfig` object here

            swiperFromConfig(sliderContainer, userConfig);
        });
    }
}
